import { User } from "./User";

export interface Customer {
  _id?: string;
  user?: User;
  name?: string;
  profileImage?: string;
  homeAddress?: HomeAddress;
  phoneNumber?: PhoneNumber;
  gender?: Gender;
  age?: number;
}

export enum Gender {
  MALE = "male",
  FEMALE = "female",
}

export interface PhoneNumber {
  number: string;
  countryCode: string;
  countryISOCode: string;
}

export interface HomeAddress {
  country: string;
  zoneNumber: string;
  streetNumber: string;
  buildingNumber: string;
  floorNumber: string;
}

export function getFullAddress(homeAddress: HomeAddress): string {
  return `${homeAddress.country}, ${homeAddress.zoneNumber}, ${homeAddress.streetNumber}, ${homeAddress.buildingNumber}, ${homeAddress.floorNumber}`;
}
